<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
  >
    <v-card class="pt-4 pr-4 pl-4" flat max-width="500">
      <v-form ref="form" v-model="valid">
        <v-card-text>{{ $t("report.leasingDetails.isLeasing") }}</v-card-text>
        <v-radio-group v-model="isLeasing">
          <v-radio :label="$t('report.leasingDetails.yes')" :value="true"></v-radio>
          <v-radio :label="$t('report.leasingDetails.no')" :value="false"></v-radio>
        </v-radio-group>
        <div v-if="leasingDetails">
          <v-card-text v-if="leasingDetails.isLeasing">{{ $t("report.leasingDetails.leasingCompany") }}</v-card-text>
          <v-radio-group v-if="leasingDetails.isLeasing" v-model="leasingDetails.company">
            <v-radio
              v-for="leasingPartner of LEASING_OPTIONS"
              :key="leasingPartner"
              :label="leasingPartner"
              :value="leasingPartner"
            ></v-radio>
          </v-radio-group>
          <div v-if="claimNumberIsRequired && leasingDetails.company">
            <v-card-text>{{
              $t("report.leasingDetails.claimNumber.isRequired", { company: leasingDetails.company })
            }}</v-card-text>
            <v-text-field
              outlined
              :label="$t('report.leasingDetails.claimNumber.isRequiredLabel')"
              :rules="requiredRule"
              v-model="leasingDetails.claimNumber"
            />
          </div>
          <div v-else-if="!leasingDetails.isLeasing || leasingDetails.company === OTHER">
            <v-card-text>{{ $t("report.leasingDetails.claimNumber.isOptional") }}</v-card-text>
            <v-text-field
              outlined
              :label="$t('report.leasingDetails.claimNumber.isOptinalLabel')"
              v-model="leasingDetails.claimNumber"
            />
          </div>
        </div>
      </v-form>
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { requiredRule } from "@/lib/rules/requiredRule";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { MrfiktivLeasingDetailsGen } from "@/services/mrfiktiv/v1/data-contracts";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep
  }
})
export default class ReportLeasing extends ReportStepMixin implements IReportStep {
  ARVAL = "Arval";
  LEASPLAN = "Leaseplan";
  OTHER = "Anderer";

  LEASING_OPTIONS = [this.ARVAL, this.LEASPLAN, this.OTHER];

  get isLeasing() {
    return this.leasingDetails.isLeasing;
  }

  set isLeasing(isLeasing: boolean) {
    if (!isLeasing) {
      this.leasingDetails.company = "";
    }
    this.leasingDetails.isLeasing = isLeasing;
  }

  get header(): IReportHeaderData {
    return {
      title: "report.leasingDetails.title",
      description: "report.leasingDetails.description"
    };
  }
  screen = ReportScreenEnum.leasing;

  valid = false;

  get isDone() {
    if (this.leasingDetails.isLeasing && !this.leasingDetails.company) {
      return false;
    }
    if (!this.valid) {
      return false;
    }
    return true;
  }

  claimNumberRequired = [this.ARVAL, this.LEASPLAN];

  get claimNumberIsRequired() {
    return this.claimNumberRequired.includes(this.leasingDetails.company || "");
  }

  get requiredRule() {
    const rules = [];

    rules.push(requiredRule());

    return rules;
  }

  get body() {
    return ReportModule.body;
  }

  get leasingDetails(): MrfiktivLeasingDetailsGen {
    return ReportModule.leasing as MrfiktivLeasingDetailsGen;
  }

  set leasingDetails(leasing: MrfiktivLeasingDetailsGen) {
    ReportModule.setLeasing(leasing);
  }

  created() {
    if (!this.leasingDetails) {
      ReportModule.setLeasing({ isLeasing: true, company: "", claimNumber: "" });
    }
  }
}
</script>
